import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import './standalonePageEntrypointBanner';
import '@slickdeals/blueprint-twig/javascript/patterns/storeLink';
import '@slickdeals/blueprint-twig/javascript/patterns/articleContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/dealContentListModule';
import '../patterns/sidebarDeals';
import '../patterns/inlineResponse';
import { initPage } from '../utilities/initPage';
import { initInclickTracking, } from '../utilities/eventTracking';
import { inclickSources } from '../utilities/inclickSources';
import readyState from 'ready-state';
new LazyLoad(); // eslint-disable-line no-new
initPage();
const getDealRowData = (card) => {
    var _a, _b, _c, _d;
    const uniqueId = card.getAttribute('data-threadid') || '';
    if (!uniqueId) {
        return null;
    }
    return {
        uniqueId,
        dealTitle: ((_b = (_a = card.querySelector('.dealTitle a')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '',
        isExpired: false,
        listPriceText: '',
        finalPriceText: ((_d = (_c = card.querySelector('.priceCol .price span')) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.trim()) || '',
    };
};
const getSidebarDealData = (_card, link) => {
    var _a, _b;
    const uniqueId = ((_a = new URL(link.href, window.location.origin).pathname.match(/^\/[fe]\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
    if (!uniqueId) {
        return null;
    }
    return {
        uniqueId,
        dealTitle: ((_b = link.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '',
        isExpired: false,
        listPriceText: '',
        finalPriceText: '',
    };
};
const getDealRowActionSource = (link) => {
    if (link.hash.startsWith('#post')) {
        return inclickSources.DEAL_COMMENTS;
    }
    if (link.querySelector('img')) {
        return inclickSources.DEAL_IMAGE;
    }
    if (link.classList.contains('fb_popular_deal_title') ||
        link.closest('.dealTitle')) {
        return inclickSources.DEAL_TITLE;
    }
};
const getSidebarDealActionSource = (link) => {
    if (link.classList.contains('bp-p-sidebarDeals_titleLink')) {
        return inclickSources.SIDEBAR_DEAL_TITLE;
    }
};
readyState.domready.then(() => {
    const mainList = document.querySelector('[data-module-name="Popular Deals List"]');
    if (mainList) {
        initInclickTracking(mainList, '.dealRow', {
            containerName: 'Popular Deals List',
            containerType: 'feed',
            getDealData: getDealRowData,
            getActionSource: getDealRowActionSource,
        });
    }
    const sidebar = document.querySelector('[data-module-name="Trending Deals"]');
    if (sidebar) {
        initInclickTracking(sidebar, '.bp-p-sidebarDeals_deal', {
            containerName: 'Trending Deals',
            containerType: 'sidebar',
            getDealData: getSidebarDealData,
            getActionSource: getSidebarDealActionSource,
        });
    }
});
